import Macy from "macy";

export default () => ({
  endpoint: "https://api.flockler.com/v1/sites/18645/articles?count=6",
  macy: null,
  hasError: false,
  isLoading: false,
  posts: [],
  response: {
    pagination: {
      older: null,
    },
  },

  init() {
    this.getPosts();
    this.initMacyGrid();
  },

  getPosts() {
    fetch(this.endpoint)
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.json();
        } else {
          this.hasError = true;

          throw Error(`${response.status} - ${response.statusText}`);
        }
      })
      .then((data) => {
        this.response = data;
        this.posts = data.articles;
      })
      .catch((e) => {
        console.log(e);
      });
  },

  loadMore() {
    this.isLoading = true;

    fetch(this.response.pagination.older)
      .then((response) => response.json())
      .then((data) => {
        this.response = data;
        let newPosts = this.posts;

        newPosts.push(...data.articles);
        this.posts = newPosts;

        setTimeout(() => {
          this.macy.reInit();
        }, 200);

        this.isLoading = false;
      });
  },

  initMacyGrid() {
    // init masonry grid layout
    setTimeout(() => {
      this.macy = Macy({
        container: ".masonry-grid",
        mobileFirst: true,
        margin: 20,
        columns: 1,
        breakAt: {
          600: {
            columns: 2,
          },
          850: {
            columns: 3,
          },
        },
      });
    }, 500);
  },
});
